// eslint-disable-line max-lines
/**
 * djhu
 * Deprecating jQuery Helper Utility
 */

// to use fetch as ajax backend
// import Promise from 'promise-polyfill'
// import 'whatwg-fetch'

// to use rx.DOM.ajax (rxjs 4) as ajax backend
// require('rx/dist/rx.lite') or require('rx')
// require('rx-dom-ajax')

// to use rxjs 5 as ajax backend
// import Rx from 'rxjs/Rx'
// window.Rx = Rx
//  or
// import {Observable} from 'rxjs/Observable'
// import 'rxjs/add/observable/dom/ajax'
// window.Rx = {Observable: Observable}

var
OBJECT = 'object',
STRING = 'string',
FUNCTION = 'function',
URLENCODED = 'application/x-www-form-urlencoded; charset=UTF-8',
djhu = function djhu(selector) {
    var fn = {
        find: (sel) => {
            if (typeof sel == STRING) {
                return document.querySelectorAll(sel) || []
            } else if (Array.isArray(sel)) {
                return sel
            } else if (typeof self == OBJECT) {
                return [sel]
            }

            return []
        },
        apply: (handler) => {
            var elements = fn.find(selector),
                i

            // https://developer.mozilla.org/en/docs/Web/API/NodeList
            // https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
            // https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
            if (typeof elements.forEach == FUNCTION) {
                elements.forEach(handler)
            } else {
                // [].forEach.call(elements, handler)
                for (i = 0; i < elements.length; i++) {
                    Reflect.apply(handler, null, [elements[i], i]);
                }
            }

            return djhu(elements)
        },
        hasClass: (node, name) => {
            var classes = node.className.split(' ')

            return !(classes.indexOf(name) == -1)
        },
        addClass: (node, name) => {
            var classes = node.className.split(' ')

            if (classes.indexOf(name) == -1) {
                classes.push(name)
                node.className = classes.join(' ')
            }
        },
        removeClass: (node, name) => {
            var classes = node.className.split(' '),
                offset = classes.indexOf(name)

            if (offset > -1) {
                classes.splice(offset, 1)
                node.className = classes.join(' ')
            }
        },
        isHidden: (node) => {
            return (node.style.display === 'none')
        },
        showNode: (node, value) => {
            node.style.display = (value === undefined ? 'block' : value)
        },
        hideNode: (node, value) => {
            fn.showNode(node, (value === undefined ? 'none' : value))
        },
        attach: (node, eventName, callback) => {
            if (node.addEventListener) {
                node.addEventListener(eventName, callback, false)
            } else if (node.attachEvent) {
                node.attachEvent(`on${eventName}`, callback)
            }

            return false
        },
        detach: (node, eventName, callback) => {
            if (node.removeEventListener) {
                node.removeEventListener(eventName, callback, false)
            } else if (node.detachEvent) {
                node.detachEvent(`on${eventName}`, callback)
            }

            return false
        }
    },
    ret = function ret(instance) {
        var methods = {
            get: (index) => {
                var elements = fn.find(selector)

                if (elements && elements.length > index) {
                    return elements[index]
                }

                return undefined
            },
            ready: (handler) => {
                if (selector === document) {
                    document.addEventListener('DOMContentLoaded', () => {
                        Reflect.apply(handler, document, [])
                    })
                }
            },
            each: (handler) => {
                Reflect.apply(fn.apply, instance, [(item, index) => {
                    var handle = handler.bind(instance)
                    Reflect.apply(handle, item, [index, item])
                }])

                return methods
            },
            hasClass: (name) => {
                var elements = fn.find(selector)

                if (elements.length) {
                    return fn.hasClass(elements[0], name)
                }

                return false
            },
            addClass: (name) => {
                Reflect.apply(fn.apply, instance, [(node) => {
                    fn.addClass(node, name)
                }])

                return methods
            },
            removeClass: (name) => {
                Reflect.apply(fn.apply, instance, [(node) => {
                    fn.removeClass(node, name)
                }])

                return methods
            },
            on: (eventName, handler) => {
                Reflect.apply(fn.apply, instance, [(node) => {
                    var handle = handler.bind(node)
                    fn.attach(node, eventName, handle)
                }])

                return methods
            },
            click: (handler) => {
/*
                return Reflect.apply(fn.apply, instance, [(node) => {
                    var handle = handler.bind(node)
                    fn.attach(node, 'click', handle)
                }])
*/
                return methods.on('click', handler)
            },
            change: (handler) => {
/*
                return Reflect.apply(fn.apply, instance, [(node) => {
                    var handle = handler.bind(node)
                    fn.attach(node, 'change', handle)
                }])
*/
                return methods.on('change', handler)
            },
            show: () => {
                Reflect.apply(fn.apply, instance, [(node) => {
                    fn.showNode(node)
                }])

                return methods
            },
            hide: () => {
                Reflect.apply(fn.apply, instance, [(node) => {
                    fn.hideNode(node)
                }])

                return methods
            },
            is: (state) => {
                var element = this.get(0)

                switch (state) {
                    case ':hidden':
                        return fn.isHidden(element)

                    case ':visible':
                        return !fn.isHidden(element)

                    default:
                        throw 'Unsupported state'
                }
            },
            toggle: (showDisplay, hideDisplay) => {
                Reflect.apply(fn.apply, instance, [(node) => {
                    if (fn.isHidden(node)) {
                        fn.showNode(node, showDisplay)
                    } else {
                        fn.hideNode(node, hideDisplay)
                    }
                }])

                return methods
            },
            attr: (name, value) => {
                if (value === undefined) {
                    // throw new Error('unimplemented')
                    var nodes = fn.find(selector)

                    if (nodes && nodes.length) {
                        return nodes[0].getAttribute(name)
                    }

                    return undefined
                }

                Reflect.apply(fn.apply, instance, [(node) => {
                    node.setAttribute(name, value)
                }])
            },
            text: (value) => {
                Reflect.apply(fn.apply, instance, [(node) => {
                    node.textContent = value
                }])
            }
        }

        return methods
    }

    return Reflect.apply(ret, this, [this]) // eslint-disable-line no-invalid-this
},
dataTypeToAcceptHeader = (dataType) => {
    var accept;

    switch (dataType) {
        case 'json':
            accept = 'application/json'
            break

        default:
            accept = 'text'
            break
    }

    return accept
},
processBody = (data) => {
    var body,
        i

    if (typeof data === OBJECT) {
        body = []

        for (i in data) { // eslint-disable-line guard-for-in
            body.push(
                encodeURIComponent(i) + '=' +
                encodeURIComponent(data[i])
            )
        }

        return body.join('&')
    } else if (typeof data === STRING) {
        return data
    }

    return null
},
ajaxSetupData = {},
getContentType = (method, headers) => {
    switch (method) {
        case 'POST':
        case 'PUT':
            headers['Content-Type'] = URLENCODED
            break

        default:
            break
    }
},
fetchAjax = function fetchAjax(parameters) {
    var params = parameters || {},
        options = {
            credentials: 'same-origin',
            headers: {},
            method: (params.method || 'GET')
        },
        dataType = 'text'

    getContentType(options.method, options.headers)

    if (ajaxSetupData && typeof ajaxSetupData.headers === OBJECT) {
        options.headers = Object.assign(
            {},
            options.headers,
            ajaxSetupData.headers
        )
    }

    if (options.method === 'POST' || options.method === 'PUT') {
        options.body = processBody(params.data || {})
    }

    if (typeof params.dataType === STRING) {
        dataType = params.dataType
    }

    options.headers.Accept = dataTypeToAcceptHeader(dataType)

    return fetch((new Request(params.url || '', options)))
    .then((response) => {
        if (response.status >= 200 && response.status < 300) {
            switch (dataType) {
                case 'json':
                    return response.json()

                default:
                    return response.text()
            }
        } else {
            var error = new Error(response.statusText)

            error.response = response
            throw error
        }
    })
    .then((response) => {
        if (typeof params.success === FUNCTION) {
            Reflect.apply(params.success, null, [response])
        }
    })
    .catch((error) => {
        if (typeof params.error === FUNCTION) {
            Reflect.apply(params.error, null, [error])
        }
    })
},
rxAjax = function rxAjax(args) {
    var rxAjaxBackend

    if (typeof Rx.DOM === OBJECT &&
        typeof Rx.DOM.ajax === FUNCTION
    ) {
        rxAjaxBackend = Rx.DOM.ajax
    } else if (typeof Rx.Observable === FUNCTION &&
        typeof Rx.Observable.ajax === FUNCTION
    ) {
        rxAjaxBackend = Rx.Observable.ajax
    } else {
        return function unsupported() {
            // eslint-disable-next-line no-console
            console.log('no supported ajax module found')
        }
    }

    // use Rx
    return (function rxAjaxCall(parameters) {
        var params = parameters || {},
            options = {
                url: params.url,
                headers: {},
                method: (params.method || 'GET')
            },
            dataType = 'text'

        getContentType(options.method, options.headers)

        if (ajaxSetupData && typeof ajaxSetupData.headers === OBJECT) {
            options.headers = Object.assign(
                {},
                options.headers,
                ajaxSetupData.headers
            )
        }

        if (options.method === 'POST' || options.method === 'PUT') {
            options.body = processBody(params.data || {})
        }

        if (typeof params.dataType === STRING) {
            dataType = params.dataType
            options.responseType = dataType
        }

        return rxAjaxBackend(options)
        .subscribe((data) => {
            if (data.status >= 200 && data.status < 300) {
                if (typeof params.success === FUNCTION) {
                    Reflect.apply(params.success, null, [data.response])
                }
            } else if (typeof params.error === FUNCTION) {
                Reflect.apply(params.error, null, [data])
            }
        }, (error) => {
            if (typeof params.error === FUNCTION) {
                Reflect.apply(params.error, null, [error])
            }
        })
    }(args))
}

djhu.ajaxSetup = function ajaxSetup(params) {
    ajaxSetupData = params
}

djhu.ajax = function ajax(args) {
    if (typeof window.fetch === FUNCTION) {
        // console.info('using fetch shim')
        return fetchAjax(args)
    } else if (typeof Rx === OBJECT) {
        // console.info('using rxjs shim')
        return rxAjax(args)
    } else if (typeof jQuery === FUNCTION) {
        // console.info('using jQuery directly')
        return jQuery.ajax(args)
    }

    console.log('ajax unsupported') // eslint-disable-line no-console
    return null
}

djhu.getJSON = function getJSON(url, param1, param2) {
    var options = {
        url: url,
        dataType: 'json',
        success: function success() {} // eslint-disable-line no-empty-function
    }

    if (typeof param1 === FUNCTION) {
        options.success = param1
    } else if (typeof param2 === FUNCTION) {
        options.success = param2
    }

    if (typeof param1 === OBJECT) {
        options.url += (options.url.indexOf('?') === -1 ? '?' : '&') +
            processBody(param1)
    }

    return djhu.ajax(options)
}

// eslint-disable-next-line max-params
djhu.post = function post(url, data, success, returnType = 'json') {
    return djhu.ajax({
        url: url,
        data: data,
        method: 'POST',
        dataType: returnType,
        success: success
    })
}

export default djhu




// WEBPACK FOOTER //
// ./resources/assets/js/lib/util/djhu.js